<div *ngIf="phoneApp">
    <div style="text-align: center">
      <table style="min-width: 100%; max-width: 100%">
        <tr>
          <td style="min-width: 50%; vertical-align: text-top; ">
            <div style="font-family: Oswald; font-weight: bold; font-size: 28px; ">Contact Us</div>
            <div style="font-family: 'Open Sans' ; font-weight: bold; font-size: 16px; padding-top: 20px">Maher Terminals LLC</div>
            <div style="font-family: 'Open Sans' ; font-size: 16px">1210 Corbin Street</div>
            <div style="font-family: 'Open Sans' ; font-size: 16px; padding-bottom: 10px">Elizabeth, New Jersey 07201</div>
            <div style="font-family: 'Open Sans' ; font-size: 16px; ">Customer Support Hours:</div>
            <div style="font-family: 'Open Sans' ; font-size: 16px; padding-bottom: 10px"><b>Mon - Fri 8:00 am – 6:00 pm</b></div>
          </td>
        </tr>
        <tr>
          <td style="min-width: 50%; vertical-align: text-top; padding-top: 20px" >
            <div style="font-family: Oswald; font-weight: bold; font-size: 28px; ">Phone Numbers & Email</div>
            <table style="min-width: 100%; max-width: 100%; padding-top: 20px">
              <tr>
                <td style="min-width: 50%; vertical-align: bottom">
                  <img style="vertical-align: center;height:25px; width: 25px" src="assets/phone_black_24dp.svg" >
                </td>
                <td style="min-width: 50%; text-align: left">
                  <div style="font-family: 'Open Sans' ; font-size: 16px">Main:</div>
                  <div style="font-family: 'Open Sans' ; font-size: 16px; font-weight: bold">(908) 527-8200</div>
                </td>
              </tr>
              <tr>
                <td style="min-width: 50%; vertical-align: bottom">
                  <img style="vertical-align: center;height:25px; width: 25px" src="assets/phone_black_24dp.svg" >
                </td>
                <td style="min-width: 50%; text-align: left">
                  <div style="font-family: 'Open Sans' ; font-size: 16px">Customer Service and Demurrage Support:</div>
                  <div style="font-family: 'Open Sans' ; font-size: 16px; font-weight: bold">(908) 436-4844</div>
                </td>
              </tr>
              <tr>
                <td style="min-width: 50%; vertical-align: bottom">
                  <img style="vertical-align: center;height:25px; width: 25px" src="assets/email.svg" >
                </td>
                <td style="min-width: 50%; text-align: left">
                  <div style="font-family: 'Open Sans' ; font-size: 16px">For Containers Currently On Terminal:</div>
                  <div style="font-family: 'Open Sans' ; font-size: 16px; font-weight: bold"> <a href="mailto:customersupport@maherterminals.com">customersupport&#64;maherterminals.com</a></div>
                </td>
              </tr>


            </table>
          </td>
        </tr>
        <tr>
          <td  style="padding-top: 10px">
            <div style="border: #E61E00 1px solid;">
              <iframe class="map"  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3025.547450548648!2d-74.1652694842779!3d40.68393924726812!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2525db3bb0321%3A0x307e075dd844401a!2s1210%20Corbin%20St%2C%20Elizabeth%2C%20NJ%2007201!5e0!3m2!1sen!2sus!4v1641581929392!5m2!1sen!2sus" allowfullscreen="" loading="lazy"></iframe>
            </div>
          </td>
        </tr>
      </table>
    </div>
</div>


<div class="centered" *ngIf="!phoneApp" >
  <mat-card  class="myCard">
    <div class="maher" (click)="myApp.showCharts()"></div>

    <table style="min-width: 100%; max-width: 100%">
      <tr>
        <td style="min-width: 50%; vertical-align: text-top; padding-right: 136px">
          <div style="font-family: Oswald; font-weight: bold; font-size: 28px; ">Contact Us</div>
          <div style="font-family: 'Open Sans' ; font-weight: bold; font-size: 16px; padding-top: 20px">Maher Terminals LLC</div>
          <div style="font-family: 'Open Sans' ; font-size: 16px">1210 Corbin Street</div>
          <div style="font-family: 'Open Sans' ; font-size: 16px; padding-bottom: 10px">Elizabeth, New Jersey 07201</div>
          <div style="font-family: 'Open Sans' ; font-size: 16px; ">Customer Support Hours:</div>
          <div style="font-family: 'Open Sans' ; font-size: 16px; padding-bottom: 10px"><b>Mon - Fri 8:00 am – 6:00 pm</b></div>
        </td>
        <td style="min-width: 50%; vertical-align: text-top">
          <div style="font-family: Oswald; font-weight: bold; font-size: 28px; ">Phone Numbers & Email</div>
          <table style="min-width: 100%; max-width: 100%; padding-top: 20px">
            <tr>
              <td colspan="2" style="min-width: 50%; vertical-align: bottom">
                <div style="font-family: 'Open Sans' ; font-size: 16px">Main:</div>

              </td>
            </tr>
              <tr>
                <td style="min-width: 50%; text-align: left; vertical-align: bottom">
                  <mat-icon>phone</mat-icon>
                </td>
                <td style="min-width: 50%; text-align: left; ">
                  <div style="font-family: 'Open Sans' ; font-size: 16px; font-weight: bold">(908) 527-8200</div>
                </td>
              </tr>

            <tr>
              <td colspan="2" style="min-width: 50%; vertical-align: bottom; padding-top: 10px">
                <div style="font-family: 'Open Sans' ; font-size: 16px">Customer Service and Demurrage Support:</div>
              </td>
            </tr>
            <tr>
              <td style="min-width: 50%; text-align: left">
                <mat-icon>phone</mat-icon>
              </td>
              <td style="min-width: 50%; text-align: left">
                <div style="font-family: 'Open Sans' ; font-size: 16px; font-weight: bold">(908) 436-4844</div>
              </td>
            </tr>
            <tr style="    top: -12px;position: relative;">
              <td style="min-width: 50%; vertical-align: bottom; padding-top: 10px">
                <mat-icon>email</mat-icon>
              </td>
              <td style="min-width: 50%; text-align: left; ">
                <div style="font-family: 'Open Sans' ; font-size: 16px; font-weight: bold"> <a href="mailto:customersupport@maherterminals.com">customersupport&#64;maherterminals.com</a></div>
              </td>
            </tr>

          </table>

        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div style="border: #E61E00 1px solid;">
            <iframe class="map"  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3025.547450548648!2d-74.1652694842779!3d40.68393924726812!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2525db3bb0321%3A0x307e075dd844401a!2s1210%20Corbin%20St%2C%20Elizabeth%2C%20NJ%2007201!5e0!3m2!1sen!2sus!4v1641581929392!5m2!1sen!2sus" allowfullscreen="" loading="lazy"></iframe>
          </div>
        </td>
      </tr>

    </table>


  </mat-card>
</div>
